import type { ExternalSiteCheckRule } from "../../types";
import { SHOPBY_PRO_PAGE, SITE_TYPE } from "./const";

const isShopByProHomePath = (pathname: string) => {
  const result = ["/", "/index.html"].some((path) => {
    return path === pathname;
  });
  return result;
};

const shopbyPro: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target }) {
    if (target.value === "HOME" && isShopByProHomePath(url.pathname)) {
      return true;
    }
    if (
      target.value === SHOPBY_PRO_PAGE.LOGIN.target &&
      url.pathname === SHOPBY_PRO_PAGE.LOGIN.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.SIGNUP_INTRO.target &&
      url.pathname === SHOPBY_PRO_PAGE.SIGNUP_INTRO.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.SIGNUP_AGREEMENT.target &&
      url.pathname === SHOPBY_PRO_PAGE.SIGNUP_AGREEMENT.url
    ) {
      return true;
    }
    if (
      target.value === SHOPBY_PRO_PAGE.SIGNUP_MAIN.target &&
      url.pathname === SHOPBY_PRO_PAGE.SIGNUP_MAIN.url
    ) {
      return true;
    }
    if (
      target.value === SHOPBY_PRO_PAGE.MY_PAGE.target &&
      url.pathname === SHOPBY_PRO_PAGE.MY_PAGE.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.FIND_ID.target &&
      url.pathname === SHOPBY_PRO_PAGE.FIND_ID.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.FIND_PASSWORD.target &&
      url.pathname === SHOPBY_PRO_PAGE.FIND_PASSWORD.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.CART.target &&
      url.pathname === SHOPBY_PRO_PAGE.CART.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.POLICY.target &&
      url.pathname === SHOPBY_PRO_PAGE.POLICY.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.PRIVACY.target &&
      url.pathname === SHOPBY_PRO_PAGE.PRIVACY.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.PRODUCT_LIST.target &&
      url.pathname === SHOPBY_PRO_PAGE.PRODUCT_LIST.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PRO_PAGE.PRODUCT_DETAIL.target &&
      url.pathname === SHOPBY_PRO_PAGE.PRODUCT_DETAIL.url
    ) {
      return true;
    }

    return false;
  },
};

export default shopbyPro;
